import { render, staticRenderFns } from "./VideoPagination.vue?vue&type=template&id=0acf905e&scoped=true&"
import script from "./VideoPagination.vue?vue&type=script&lang=js&"
export * from "./VideoPagination.vue?vue&type=script&lang=js&"
import style0 from "./VideoPagination.vue?vue&type=style&index=0&id=0acf905e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acf905e",
  null
  
)

export default component.exports